import { User } from 'state/user/UserTypes';
import { FluxStandardAction } from 'state/StateTypes';
import { createReducer } from 'utils';
import * as actionTypes from './UsersActionTypes';
import { RESET_QUERY } from 'state/query/QueryActionTypes';

export interface UsersState {
   users: User[];
   isViewingUserDetails: boolean;
   userIndexBeingViewed?: number;
   totalPages: number;
   totalUsers: number | undefined;
}

const assignPayloadToState = <T>({ payload }: FluxStandardAction, prop: keyof UsersState): Partial<UsersState> => ({
   [prop]: payload as T,
});

const initialUsersState: UsersState = { users: [], isViewingUserDetails: false, totalPages: 1, totalUsers: undefined }

const UsersReducer = createReducer<UsersState, FluxStandardAction>(
   initialUsersState,
   {
      [actionTypes.GET_USERS]: (state, action) => ({
         ...state,
         ...assignPayloadToState<User[]>(action, 'users'),
      }),
      [actionTypes.CLEAR_USERS]: state => ({
         ...state,
         users: [],
      }),
      [actionTypes.UPDATE_USER]: (state, action) => ({
         ...state,
         users: state.users.map(user => (user._id === action.payload.id ? action.payload : user)),
      }),
      [actionTypes.SET_TOTAL_PAGES]: (state, action) => ({
         ...state,
         ...assignPayloadToState<number>(action, 'totalPages'),
      }),
      [actionTypes.SET_TOTAL_USERS]: (state, action) => ({
         ...state,
         ...assignPayloadToState<number>(action, 'totalUsers'),
      }),
      [actionTypes.SET_IS_VIEWING_USER_DETAILS]: (state, action) => ({
         ...state,
         isViewingUserDetails: action.payload as boolean,
      }),
      [actionTypes.SET_USER_BEING_VIEWED_INDEX]: (state, action) => ({
         ...state,
         ...assignPayloadToState(action, 'userIndexBeingViewed')
      }),
      [RESET_QUERY]: () => initialUsersState
   }
);

export default UsersReducer;
